import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginappComponent } from './loginapp/loginapp.component';
import { AccountsettingsComponent } from './private/accountsettings/accountsettings.component';
import { AddeventComponent } from './private/addevent/addevent.component';
import { AdminmanagementComponent } from './private/admin/adminmanagement/adminmanagement.component';
import { AdsComponent } from './private/admin/ads/ads.component';
import { AlleventsComponent } from './private/admin/allevents/allevents.component';
import { CategoriesComponent } from './private/admin/categories/categories.component';
import { DashboardComponent } from './private/admin/dashboard/dashboard.component';
import { DetailedeventComponent } from './private/admin/detailedevent/detailedevent.component';
import { ManagepartnersComponent } from './private/admin/managepartners/managepartners.component';
import { ParatnerscategoryComponent } from './private/admin/paratnerscategory/paratnerscategory.component';
import { PendingeventsComponent } from './private/admin/pendingevents/pendingevents.component';
import { SponsoredeventsComponent } from './private/admin/sponsoredevents/sponsoredevents.component';
import { UsermanagementComponent } from './private/admin/usermanagement/usermanagement.component';
import { FavoritesComponent } from './private/favorites/favorites.component';
import { MybookingsComponent } from './private/mybookings/mybookings.component';
import { MycreatedeventsComponent } from './private/mycreatedevents/mycreatedevents.component';
import { ResetpasswordComponent } from './private/resetpassword/resetpassword.component';
import { SponsoreventComponent } from './private/sponsorevent/sponsorevent.component';
import { AboutComponent } from './public/about/about.component';
import { PartnersComponent } from './public/about/partners/partners.component';
import { EventPageComponent } from './public/event-page/event-page.component';
import { MainComponent} from './public/main/main.component'
import { VerifyEmailComponent } from './public/verify-email/verify-email.component';
import { EditeventComponent } from './private/editevent/editevent.component';
import { BulkemailComponent } from './private/admin/bulkemail/bulkemail.component';
import { DetailedadComponent } from './private/admin/detailedad/detailedad.component';
import { GetInTouchComponent } from './public/about/get-in-touch/get-in-touch.component';
import { RibbonComponent } from './private/admin/ribbon/ribbon.component';
import { CreateadComponent } from './private/createad/createad.component'
import { PendingadsComponent } from './private/admin/pendingads/pendingads.component';
import { ManagepackagesComponent } from './private/admin/managepackages/managepackages.component';
import { ApidocsComponent } from './public/about/apidocs/apidocs.component'
import { RecyclingComponent } from './public/recycling/recycling.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'main' },
  { path: 'sec/loginapp', component: LoginappComponent },
  { path: 'main', component: MainComponent },
  { path: 'event/:eventName', component: EventPageComponent },
  { path: 'mybookings', component: MybookingsComponent },
  { path: 'verify-email', component: VerifyEmailComponent },
  { path: 'addevent', component: AddeventComponent },
  { path: 'favorites', component: FavoritesComponent },
  { path: 'myaccount', component: AccountsettingsComponent },
  { path: 'password-reset', component: ResetpasswordComponent },
  { path: 'mycreatedevents', component: MycreatedeventsComponent },
  { path: 'sponsorevent', component: SponsoreventComponent },
  { path: 'admin/dashboard', component: DashboardComponent },
  { path: 'admin/pendingevents', component: PendingeventsComponent },
  { path: 'admin/allevents', component: AlleventsComponent },
  { path: 'admin/sponsoredevents', component: SponsoredeventsComponent },
  { path: 'admin/detailedevent', component: DetailedeventComponent },
  { path: 'admin/adminmanagement', component: AdminmanagementComponent },
  { path: 'admin/usermanagement', component: UsermanagementComponent },
  { path: 'admin/categories', component: CategoriesComponent },
  { path: 'admin/ads', component: AdsComponent },
  { path: 'editevent', component: EditeventComponent},
  { path: 'admin/managepartners', component: ManagepartnersComponent },
  { path: 'admin/partnerscategory', component: ParatnerscategoryComponent },
  { path: 'admin/bulkemail', component: BulkemailComponent},
  { path: 'admin/ribbon', component: RibbonComponent},
  { path: 'about', component: AboutComponent },
  { path: 'partners', component: PartnersComponent },
  { path: 'admin/detailedad', component: DetailedadComponent},
  { path: 'getintouch', component: GetInTouchComponent },
  { path: 'createad', component: CreateadComponent },
  { path: 'admin/pendingads', component: PendingadsComponent },
  { path: 'admin/managepackages', component: ManagepackagesComponent },
  { path: 'apidocs', component: ApidocsComponent },
  { path: 'recycling', component: RecyclingComponent }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
